<template>
  <div id="banner">
    <div class="media-container">
      <ImageC
        :imageSmall="imageSmall"
        :imageLarge="imageLarge"
        :paddingBottom="paddingBottom"
      />
      <div class="overlay">
        <div class="slogan has-text-centered">
          <h1 class="slogan-title">
            {{ title }}
          </h1>
          <h2 class="slogan-subtitle" v-html="desc"></h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageC from './ImageC';

export default {
  name: 'banner',
  props: {
    imageSmall: String,
    imageLarge: String,
    paddingBottom: String,
    title: String,
    desc: String,
  },
  components: {
    ImageC,
  },
};
</script>

<style lang="scss" scoped>
.slogan {
  @media screen and (min-width: 768px) {
    padding: 0 4rem;
  }

  padding: 0 1rem;
}

.slogan-title {
  font: 100 40px/1.5 'Pacifico', Helvetica, sans-serif;
  color: white;
  padding-top: 1em;
  padding-bottom: 20px;
  font-weight: 400;
  line-height: 1.2em;

  @media screen and (max-width: 768px) {
    font-size: 2em;
    padding-top: 0.6em;
  }
}

.slogan-subtitle {
  font-weight: 300;
  color: white;
  font-size: 1.5em;

  @media screen and (max-width: 768px) {
    font-size: 1em;
  }
}

.media-container {
  position: relative;
}

.overlay {
  position: absolute;
  display: inline-flex; // safari
  background: rgba(102, 102, 102, 0.85);
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  zoom: 1;

  .slogan {
    position: relative;
    // transform: translateY(-50%);
    // top: 45%;
    width: 100%;
    -webkit-align-self: center; //safari 7+
    align-self: center;
  }
}

img {
  margin-bottom: -5px;
}

.button {
  margin-top: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue